import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//教材管理相关API...

const textbookManage = {
    statistics: {
        queryList: config => createAPI('/textbookManage/statistics/queryList', 'post', config),
        bookInfoList: config => createAPI('/textbookManage/statistics/bookInfoList', 'post', config),
        detailInfoList: config => createAPI('/textbookManage/statistics/detailInfoList', 'post', config),
        download: config => createAPI('/textbookManage/statistics/download', 'post', config),
        printFile: config => createAPI('/textbookManage/statistics/printFile', 'post', config),
    },
    textbook: {
        queryList: config => createAPI('/textbookManage/textbook/queryList', 'post', config),
        option: config => createAPI('/textbookManage/textbook/option', 'post', config),
        save: config => createAPI('/textbookManage/textbook/save', 'post', config),
        del: config => createAPI('/textbookManage/textbook/del', 'post', config),
        upload: config => createAPI('/textbookManage/textbook/upload', 'post', config),
        updateAuditState: config => createAPI('/textbookManage/textbook/updateAuditState', 'post', config),
        fjUpload: config => createAPI('/textbookManage/textbook/fjUpload', 'post', config),
        loadFjTable: config => createAPI('/textbookManage/textbook/loadFjTable', 'post', config),
        delFj: config => createAPI('/textbookManage/textbook/delFj', 'post', config),
        updateState: config => createAPI('/textbookManage/textbook/updateState', 'post', config),
        updateQyztsm: config => createAPI('/textbookManage/textbook/updateQyztsm', 'post', config),
        queryTextbookAwardList: config => createAPI('/textbookManage/textbook/queryTextbookAwardList', 'post', config),
        saveTextbookAward: config => createAPI('/textbookManage/textbook/saveTextbookAward', 'post', config),
        updateSfsbState: config => createAPI('/textbookManage/textbook/updateSfsbState', 'post', config),
        queryAuditFlow: config => createAPI('/textbookManage/textbook/queryAuditFlow', 'post', config),
    },
    register: {
        queryList: config => createAPI('/textbookManage/register/queryList', 'post', config),
        option: config => createAPI('/textbookManage/register/option', 'post', config),
        bookInfoList: config => createAPI('/textbookManage/register/bookInfoList', 'post', config),
        save: config => createAPI('/textbookManage/register/save', 'post', config),
        getRegisterInfo: config => createAPI('/textbookManage/register/getRegisterInfo', 'post', config),
        updateAuditState: config => createAPI('/textbookManage/register/updateAuditState', 'post', config),
        delBook: config => createAPI('/textbookManage/register/delBook', 'post', config),
        loadPxb: config => createAPI('/textbookManage/register/loadPxb', 'post', config),
        exportFile: config => createAPI('/textbookManage/register/exportFile', 'post', config),
        stopMod: config => createAPI('/textbookManage/register/stopMod', 'post', config),
        auditTable: config => createAPI('/textbookManage/register/auditTable', 'post', config),
        loadBatchRegisterCourse: config => createAPI('/textbookManage/register/loadBatchRegisterCourse', 'post', config),
        loadBatchRegisterClass: config => createAPI('/textbookManage/register/loadBatchRegisterClass', 'post', config),
        saveBatch: config => createAPI('/textbookManage/register/saveBatch', 'post', config),
        queryAuditFlow: config => createAPI('/textbookManage/register/queryAuditFlow', 'post', config),
    },
    registerTimeSet: {
        queryList: config => createAPI('/textbookManage/registerTimeSet/queryList', 'post', config),
        save: config => createAPI('/textbookManage/registerTimeSet/save', 'post', config),
        del: config => createAPI('/textbookManage/registerTimeSet/del', 'post', config),
        loadRegisterTimeRole: config => createAPI('/textbookManage/registerTimeSet/loadRegisterTimeRole', 'post', config),
    },
};


export default textbookManage;



// WEBPACK FOOTER //
// ./src/api/modules/textbookManage.js